export default __webpack_public_path__ + "static/media/Culture.c09b2f62.svg";